import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grey['400'],
    position: 'relative',
    height: '100%',
    width: '100%',
    overflow: 'auto',
    border: '1px solid',
  },
  expander: {
    minHeight: '100%',
    minWidth: '100%',
    position: 'relative',
  },
  dummyContainer: {
    position: 'absolute',
  },
}))

export default useStyles
